"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n  }\n\n  &.medium-image {\n    width: 26px;\n    height: 26px;\n  }\n\n  &.big-image {\n    width: 30px;\n    height: 30px;\n  }\n\n  &.profile-image {\n    width: 40px;\n    height: 40px;\n  }\n\n  &.retailer-image {\n    width: 50px;\n    height: 50px;\n  }\n"])));

exports.Container = Container;